module.exports = __webpack_public_path__ + "static/media/product-1-full.ab7401de.jpg";